/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Templatefileid2Inputs */

const en__field_templatefileid2 = /** @type {(inputs: _Field_Templatefileid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template file ID`)
};

/** @type {(inputs: _Field_Templatefileid2Inputs) => LocalizedString} */
const de__field_templatefileid2 = en__field_templatefileid2;

/**
* | output |
* | --- |
* | "Template file ID" |
*
* @param {_Field_Templatefileid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_templatefileid2 = /** @type {((inputs?: _Field_Templatefileid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Templatefileid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_templatefileid2(inputs)
	return de__field_templatefileid2(inputs)
});
export { _field_templatefileid2 as "_field_templateFileId" }